const getters = {
  getCompanyId: (state, getters, rootState) => {
    return rootState['$_user'].user.profile.companyid;
  },
  getCurrentCompanies: (state, getters, rootState) => {
    return rootState['$_user'].companies;
  },
  getCurrentCompany: (state, getters, rootState) => {
    return rootState['$_user'].companies[0];
  },
};

export default getters;
